var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE3F85",
    d: "M53.7,-15.9C60.8,4.3,51.6,31.3,30.6,48C9.6,64.7,-23.3,71,-45.6,56.3C-67.9,41.6,-79.7,5.9,-70.3,-17.4C-61,-40.8,-30.5,-51.9,-3.6,-50.7C23.3,-49.5,46.7,-36.1,53.7,-15.9Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.c92fb732171309967eac662a1edb5336.svg";
export { ForwardRef as ReactComponent };